import { render, staticRenderFns } from "./ClinicAddEdit.vue?vue&type=template&id=d5627752&"
import script from "./ClinicAddEdit.vue?vue&type=script&lang=js&"
export * from "./ClinicAddEdit.vue?vue&type=script&lang=js&"
import style0 from "./ClinicAddEdit.vue?vue&type=style&index=0&id=d5627752&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports